// extracted by mini-css-extract-plugin
module.exports = {"group":"PlanSpaceGroup_group__9BzW9","title":"PlanSpaceGroup_title__NFw7U","column":"PlanSpaceGroup_column__X5upu","content":"PlanSpaceGroup_content__j7N5T"};